import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 53,
    orderStatus: 1,
    serviceOption: "",
    servicePriority: 0,
    sampleAmount: 1,
    additionalComments: "",
	sangerOption: 1,
    tableData: [],
    sangerData: [
        {id: 1, library: "", pName: "", pConc: 0, pbp: false},
        {id: 2, library: "", pName: "", pConc: 0, pbp: false},
    ]
  },
};

//creates the user slice with the initial state and actions
const wpsDqcFormSlice = createSlice({
  name: "wpsDqc",
  initialState,
  reducers: {
    //action creators
    initializeWpsDqc(state, action) {
      for (let i = 0; i < 1; i++) {
        const newObj = {
          id: i + 1,
          sampleID: "",
          sampleConc: "",
          sampleType: "",
          targetSize: '',
          dataAnalysis: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
  
    resetWpsDqcState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetWpsDqcPage(state, action) {
      state.page = 0 ;
      return;
    },
    editWpsDqcRow(state, action) {
      const { index, value, property } = action.payload;
		let pattern = /^[a-zA-Z0-9-_]{0,30}$/;
      const updatedData = [...state.data.tableData];

      if (property === "sampleID") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
			alert("Only special characters allowed: hyphen( - ) and underscore( _ ).\nMax character length = 30.");
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    editWpsDqcSangerRow(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.sangerData];
      
      updatedData[index][property] = value;

      // Assuming your state has a property named "tableData"
      state.data.sangerData = updatedData;
    },
    increaseWpsDqcConcentration(state, action) {
      const { index, property } = action.payload;
      if(property === 'pConc'){
        state.data.sangerData[index][property] = Number(state.data.sangerData[index][property]) + 1;
      }
      else {
        state.data.tableData[index][property] = Number(state.data.tableData[index][property]) + 1;
      }
    },
    decreaseWpsDqcConcentration(state, action) {
      const { index, property } = action.payload;
      if(property === 'pConc'){
        if (state.data.sangerData[index][property] > 0) {
          state.data.sangerData[index][property] = Number(state.data.sangerData[index][property]) - 1;
        }
      }
      else {
        if (state.data.tableData[index][property] > 0) {
          state.data.tableData[index][property] = Number(state.data.tableData[index][property]) - 1;
        }
      }
    },
    editWpsDqcComments(state, action) {
      state.data.additionalComments = action.payload;
    },
    clearWpsDqcSelect(state, action) {
      const { index, property } = action.payload;

      state.data.sangerData[index] = {
        ...state.data.sangerData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    wpsDqcPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    wpsDqcNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    setWpsDqcOrderNumber: (state, action) => {
      state.data.orderNumber = action.payload
    },
    setWpsDqcSangerOption: (state, action) => {
      state.data.sangerOption = action.payload
      if(Number(action.payload) === 2){
        state.data.sangerData = [
        {id: 1, library: "", pName: "", pConc: 0, pbp: false},
        {id: 2, library: "", pName: "", pConc: 0, pbp: false},
        ]
      }
    },
    toggleWpsDqcCheckbox(state, action) {
      const { index, property } = action.payload;
      const newData = [...state.data.sangerData];
      newData[index][property] = !newData[index][property];
      state.data.sangerData = newData;
    },
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return [];
    });
  },
});

export const {
  initializeWpsDqc,
  resetWpsDqcState,
  resetWpsDqcPage,
  editWpsDqcRow,
  editWpsDqcSangerRow,
  increaseWpsDqcConcentration,
  decreaseWpsDqcConcentration,
  editWpsDqcComments,
  clearWpsDqcSelect,
  wpsDqcNextStep,
  setWpsDqcOrderNumber,
  wpsDqcPrevStep,
  setWpsDqcSangerOption,
  toggleWpsDqcCheckbox,
} = wpsDqcFormSlice.actions;
export const wpsDqcReducer = wpsDqcFormSlice.reducer;
